import PropTypes from "prop-types";

const propTypes = {
  odberatel: PropTypes.shape({
    I_ORGAN: PropTypes.number,
    I_O_TYP: PropTypes.number,
    TYP_OSOBY: PropTypes.string,
    NAZOV: PropTypes.string,
    ICO: PropTypes.string,
    PRAVNAFORMA: PropTypes.string,
    DIC: PropTypes.string,
    ICO_DIC: PropTypes.string,
    IC_DPH: PropTypes.string,
    STATUTAR: PropTypes.string,
    N_M: PropTypes.string,
    PSC: PropTypes.string,
    ULICA: PropTypes.string,
    CS: PropTypes.string,
    CO: PropTypes.string,
    STAT: PropTypes.string,
    EMAIL1: PropTypes.string,
    TELEFON: PropTypes.string,
    ADRESA_SIDLO: PropTypes.string,
    I_DODAVATEL: PropTypes.number,
  }),
};

export default propTypes;
